/**
 * SMS PDU segment / credit estimate (GSM-7 vs UCS-2). Kept in sync with st-ck-server
 * `helpers/systemTemplateEstimatedCreditCost.ts`.
 */

const GSM7_SINGLE = new Set<string>(
    (
        '@£$¥èéùìòÇ' +
        '\n' +
        'Øø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ ' +
        'ÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡' +
        'ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿' +
        'abcdefghijklmnopqrstuvwxyzäöñüà' +
        '\f'
    ).split('')
);

const GSM7_EXTENDED = new Set<string>(['|', '^', '€', '{', '}', '~', '[', ']', '\\']);

function gsm7SeptetLength(text: string): number | null {
    let units = 0;
    for (let i = 0; i < text.length; i++) {
        const c = text[i];
        if (GSM7_SINGLE.has(c)) {
            units += 1;
        } else if (GSM7_EXTENDED.has(c)) {
            units += 2;
        } else {
            return null;
        }
    }
    return units;
}

export function computeSmsEstimatedCreditCost(templateContent: string): number {
    const text = templateContent ?? '';
    const septets = gsm7SeptetLength(text);
    if (septets !== null) {
        if (septets <= 0) {
            return 1;
        }
        if (septets <= 160) {
            return 1;
        }
        return Math.ceil(septets / 153);
    }
    const ucsUnits = text.length;
    if (ucsUnits <= 0) {
        return 1;
    }
    if (ucsUnits <= 70) {
        return 1;
    }
    return Math.ceil(ucsUnits / 67);
}

export function getSmsSegmentInfo(templateContent: string): {
    segments: number;
    encoding: 'GSM-7' | 'UCS-2';
} {
    const text = templateContent ?? '';
    const septets = gsm7SeptetLength(text);
    return {
        segments: computeSmsEstimatedCreditCost(text),
        encoding: septets !== null ? 'GSM-7' : 'UCS-2',
    };
}
